const SUPABASE_BASE = "https://bhvsqiffenuabtwekgsj.supabase.co/storage/v1/object/public/images";

export function getImageUrl(path: string): string {
  return `${SUPABASE_BASE}/${path}`;
}
